"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebClientRequesterWrapper = void 0;
/**
 * Takes a requester and adds helper methods to the requester to allow separation
 * between the method and params
 */
var WebClientRequesterWrapper = /** @class */ (function () {
    function WebClientRequesterWrapper(requester) {
        this.requester = requester;
    }
    WebClientRequesterWrapper.createSender = function (requester, method) {
        return (new WebClientRequesterWrapper(requester)).createSender(method);
    };
    WebClientRequesterWrapper.prototype.createSender = function (method) {
        var _this = this;
        return function (params) { return _this.sendMethod(method, params); };
    };
    WebClientRequesterWrapper.sendMethod = function (requester, method, params) {
        return (new WebClientRequesterWrapper(requester)).sendMethod(method, params);
    };
    WebClientRequesterWrapper.prototype.sendMethod = function (method, params) {
        return this.send({ method: method, params: params });
    };
    WebClientRequesterWrapper.prototype.send = function (webClientRequest) {
        return this.requester.send(webClientRequest);
    };
    return WebClientRequesterWrapper;
}());
exports.WebClientRequesterWrapper = WebClientRequesterWrapper;
//# sourceMappingURL=webClientRequester.js.map